import type { IconFrameStyles } from './sidebarStyles';

export const NavItemCornerBracket = ({ styles }: { styles: IconFrameStyles }) => (
  styles.cornerBracketContainer
    ? (
      <span data-nav-corner-bracket='true' css={styles.cornerBracketContainer}>
        <span css={[styles.cornerBracketBase, styles.cornerBracketTopLeft]} />
        <span css={[styles.cornerBracketBase, styles.cornerBracketTopRight]} />
        <span css={[styles.cornerBracketBase, styles.cornerBracketBottomLeft]} />
        <span css={[styles.cornerBracketBase, styles.cornerBracketBottomRight]} />
      </span>
    )
    : null
);
